import * as React from "react";
import { makeStyles, createStyles, Paper } from "@material-ui/core";
import { domain, getUserFromStorage, Text, RelodeTheme, Button, } from "../..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                padding: theme.spacing(2),
            },
            header: {
                marginBottom: 15,
            },
            truncatedText: {
                overflow: "hidden",
                height: 70,
                whiteSpace: "pre-line",
            },
            fullText: {
                whiteSpace: "pre-line",
            },
            expandButton: {
                color: "black",
                backgroundColor: "#fbfafd",
                fontSize: 16,
                fontWeight: "bold",
                textAlign: "center",
                padding: theme.spacing(1),
                border: "none",
                width: "100%",
            },
        }),
    { name: "InternalNotes" }
);

interface InternalNotesProps {
    title?: string;
    jobDescription: string;
}

export const InternalNotes = (props: InternalNotesProps) => {
    const { title, jobDescription } = props;
    const classes = useStyles({});
    const [hideText, setHideText] = React.useState(true);
    const [buttonText, setButtonText] = React.useState("show more content");
    const [hideButton, setHideButton] = React.useState(false);
    const [panelTitle, setPanelTitle] = React.useState("internal notes");

    const user = getUserFromStorage();
    const isClient = user.role === domain.UserRole.Client || user.role === domain.UserRole.ClientAdmin ;

    const toggleHideText = (e: React.MouseEvent) => {
        e.preventDefault();

        if (hideText) {
            setHideText(false);
            setButtonText("show less content");
        } else {
            setHideText(true);
            setButtonText("show more content");
        }
    };

    React.useEffect(() => {
        const textLength = document.getElementById(
            "internalNotes-jobDescription-text"
        ).offsetHeight;

        if (textLength > 72) {
            setHideButton(true);
        }
    }, [jobDescription]);

    React.useEffect(() => {
        if (title) {
            setPanelTitle(title);
        }
    }, [title]);

    return (
        <Paper elevation={isClient ? 0 : 1 } className={classes.paper}>
                <Text variant="h2" gutterBottom>
                    {panelTitle}
                </Text>
                <Text
                    id="internalNotes-jobDescription-text"
                    dataCy="internalNotes-jobDescription-text"
                    variant="body1"
                    className={
                        hideText && !!hideButton
                            ? classes.truncatedText
                            : classes.fullText
                    }
                >
                    {jobDescription}
                </Text>
            {!!hideButton ? (
                <Button
                    className={classes.expandButton}
                    onClick={toggleHideText}
                >
                    {buttonText}
                </Button>
            ) : null}
        </Paper>
    );
};
